import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'

export const Location = () => {
  return (
    <section
      className={`
        bg-white py-16

        lg:py-20
      `}
    >
      <MainContainer
        className={`
          px-4

          sm:px-6
        `}
      >
        <div
          className={`
            grid grid-cols-1 gap-10

            lg:grid-cols-2 lg:gap-16
          `}
        >
          <div>
            <SectionEyebrow>Donde encontrarnos</SectionEyebrow>
            <h2
              className={`
                mb-10 text-h3 text-primary-800

                lg:text-h2
              `}
            >
              Visítanos en Barcelona
            </h2>

            <dl className="flex flex-col gap-6">
              <div
                className={`
                  flex flex-col gap-2 border-b border-neutral-75 pb-6 text-black

                  sm:flex-row
                `}
              >
                <dt
                  className={`w-[100px] text-subtitle1-medium text-neutral-400`}
                >
                  Dirección
                </dt>
                <dd className="flex-1 text-base-medium">
                  <span className="font-bold">Ronda General Mitre 38-40</span>
                  <br />
                  Local comercial sótano 1, 08017
                  <br />
                  Barcelona
                  <br />
                  <span className="text-neutral-400">
                    Junto a Mooby Gran Sarrià Multicines
                  </span>
                </dd>
              </div>

              <div
                className={`
                  flex flex-col gap-2 border-b border-neutral-75 pb-6

                  sm:flex-row
                `}
              >
                <dt
                  className={`w-[100px] text-subtitle1-medium text-neutral-400`}
                >
                  Horarios
                </dt>
                <dd className="flex-1 text-base-medium">
                  Lun – Vie: 10:00–14:00 · 15:00–19:00
                  <br />
                  Sábados: 10:00–14:00
                  <br />
                  Dom y festivos: cerrado
                </dd>
              </div>

              <div
                className={`
                  flex flex-col gap-2

                  sm:flex-row
                `}
              >
                <dt
                  className={`w-[100px] text-subtitle1-medium text-neutral-400`}
                >
                  Teléfono
                </dt>
                <dd className="flex-1 text-base-medium">931 318 618</dd>
              </div>
            </dl>
          </div>

          <div
            className={`
              h-[280px] w-full overflow-hidden rounded-lg

              lg:h-[400px]
            `}
          >
            <iframe
              title="Mapa Gama Óptima"
              src="https://www.google.com/maps?q=Gama+%C3%93ptima,+Ronda+General+Mitre+38-40,+Barcelona&ll=41.3948219,2       
          +.1338978&z=17&output=embed"
              className={`h-full w-full border-0`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </MainContainer>
    </section>
  )
}
